import * as React from 'react';
import clsx from 'clsx';
import type { PaymentStatus } from '@/types/payment';

interface StatusBadgeProps {
  status: PaymentStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <div
    className={clsx(
      'flex items-center justify-center',
      'h-[26px] w-[93px] rounded-16',
      'backdrop-blur-[44px]',
      // Status specific colors
      status === 'Paid' && 'bg-green-paid',
      status === 'Pending' && 'bg-yellow-500',
      status === 'Failed' && 'bg-red-500',
      status === 'Refunded' && 'bg-gray-650'
    )}
  >
    <div className='flex items-center gap-1.5'>
      {/* Dot */}
      <div className='size-1.5 rounded-full bg-white' />
      {/* Text */}
      <span className='font-sans text-12 font-medium leading-nav text-white'>{status}</span>
    </div>
  </div>
);
